import { Link } from 'react-router-dom';
import { FaMapMarkedAlt, FaUserCog } from "react-icons/fa";
import { SiGoogleforms } from "react-icons/si";
import { FaList } from "react-icons/fa6";
import { TbReportAnalytics } from "react-icons/tb";
import { Card } from "@heroui/react";
import Navbar from '../components/Navbar';

const Home: React.FC = () => {
    return (
        <div className="w-screen min-h-screen bg-white flex flex-col">
            <Navbar />
            <main className="flex flex-col items-center justify-start p-4 ">
                {/* Card Container */}
                <div className="flex flex-col gap-4 w-full max-w-(--breakpoint-sm)">
                    {/* Data Input Card */}
                    <Link to="/datainput" className="w-full">
                        <Card isBlurred className="w-full p-4 bg-primary/100 border-white/20">
                            <div className="flex flex-row items-center">
                                <SiGoogleforms size={64} className="text-[#00819e]" color="#fff" />
                                <h3 className="text-xl ml-5 font-semibold text-white">New Entry</h3>
                            </div>
                        </Card>
                    </Link>

                    {/* Map Card */}
                    <Link to="/records" className="w-full">
                        <Card isBlurred className="w-full p-4 bg-primary/100 border-white/20">
                            <div className="flex flex-row items-center">
                                <FaList size={64} className="text-[#00819e]" color="#fff"/>
                                <h3 className="text-xl ml-5 font-semibold text-white">Records</h3>
                            </div>
                        </Card>
                    </Link>

                    {/* Map Card */}
                    <Link to="/map" className="w-full">
                        <Card isBlurred className="w-full p-4 bg-primary/100 border-white/20">
                            <div className="flex flex-row items-center">
                                <FaMapMarkedAlt size={64} className="text-[#00819e]" color="#fff"/>
                                <h3 className="text-xl ml-5 font-semibold text-white">Map</h3>
                            </div>
                        </Card>
                    </Link>

                    <Link to="/reporting" className="w-full">
                        <Card isBlurred className="w-full p-4 bg-primary/100 border-white/20">
                            <div className="flex flex-row items-center">
                                <TbReportAnalytics size={64} className="text-[#00819e]" color="#fff"/>
                                <h3 className="text-xl ml-5 font-semibold text-white">Reporting</h3>
                            </div>
                        </Card>
                    </Link>

                    {/* Admin Card */}
                    <Link to="/admin" className="w-full">
                        <Card isBlurred className="w-full p-4 bg-primary/100 border-white/20">
                            <div className="flex flex-row items-center">
                                <FaUserCog size={64} className="text-[#00819e]" color="#fff"/>
                                <h3 className="text-xl ml-5 font-semibold text-white">Admin</h3>
                            </div>
                        </Card>
                    </Link>
                </div>
            </main>
        </div>
    );
};

export default Home;
